import React from 'react';
import { Typography } from 'components/common';
import Image from 'next/image';
import Images from '@/const/images';
import Link from 'next/link';
import AppRoutes from '@/const/routes';
import { useRouter } from 'next/router';

interface Props {
	title: string | React.ReactNode;
	subtitle?: string;
	description?: string;
	children?: React.ReactNode;
	imageSrc: string;
	signInLink?: boolean;
}

export const AuthCardFromCase: React.FC<Props> = ({
	title,
	subtitle,
	description,
	children,
	imageSrc,
	signInLink = false,
}) => {
	const router = useRouter();
	const { evaluated, case_id } = router.query;
	return (
		<div className="grid m-4 lg:m-0 bg-white shadow-shadow2 w-full border border-gray-disabled rounded-2xl py-8 px-4 lg:px-[81px] lg:max-w-[762px] gap-8">
			<Image
				src={Images.logoSVG}
				alt="Logo"
				width={199}
				height={38}
				className="m-auto"
			/>
			<Image
				src={imageSrc}
				alt="image"
				width={138}
				height={138}
				className="m-auto"
			/>
			<Typography
				type="bold-36"
				className="text-center text-black !text-2xl lg:!text-4xl"
			>
				{title}
			</Typography>
			{subtitle && (
				<Typography type="semibold-30" className="text-center leading-[120%]">
					{subtitle}
				</Typography>
			)}
			{children}
			{description && (
				<Typography
					type="regular-18"
					className="text-center max-w-[560px] m-auto"
				>
					{description}
				</Typography>
			)}
			{signInLink && (
				<Typography type="regular-16" className="mx-auto -mt-4">
					Already have an account?{' '}
					<Link
						href={`${AppRoutes.CLIENTAPP_AUTH_SIGN_IN}?evaluated=${evaluated}&case_id=${case_id}`}
						className="text-purple-150 font-semibold"
					>
						Sign In
					</Link>
				</Typography>
			)}
		</div>
	);
};
